import { TDiscoveryEnvironmentKeys, TDiscoveryManifestCollection, TDiscoveryManifestFallback } from 'types';

const CURRENT_ENV: TDiscoveryEnvironmentKeys = process.env.REACT_APP_ENV as TDiscoveryEnvironmentKeys;

// local fallback copy of https://discovery.busybusy.io/
const productionFallback: TDiscoveryManifestCollection = {
  'admin-email-unsubscribe': {
    meta: {
      description: 'Call to unsubscribe a user from weekly admin email reports.',
      type: 'json-rpc',
      method: 'POST',
    },
    url: 'https://rpc.busybusy.io/email-report',
    protocol: 'https',
    port: '443',
    domain: 'rpc.busybusy.io',
    path: '/email-report',
  },

  'time-entry-export': {
    meta: {
      'description': 'Provides broad time entry CSV export capability for import into other systems',
      'type': 'REST',
      'method': 'GET',
      'content-type': 'text/csv',
    },
    url: 'https://export.busybusy.io',
    protocol: 'https',
    port: '443',
    domain: 'export.busybusy.io',
    path: '/',
  },
};

// local fallback copy of https://discovery.busybusy.io/staging
const stagingFallback: TDiscoveryManifestCollection = {
  'admin-email-unsubscribe': {
    meta: {
      description: 'Call to unsubscribe a user from weekly admin email reports.',
      type: 'json-rpc',
      method: 'POST',
    },
    url: 'https://rpc.busybusy.io/email-report',
    protocol: 'https',
    port: '443',
    domain: 'rpc.busybusy.io',
    path: '/email-report',
  },

  'time-entry-export': {
    meta: {
      'description': 'Provides broad time entry CSV export capability for import into other systems',
      'type': 'REST',
      'method': 'GET',
      'content-type': 'text/csv',
    },
    url: 'https://export.busybusy.io',
    protocol: 'https',
    port: '443',
    domain: 'export.busybusy.io',
    path: '/',
  },
};

// local fallback copy of https://discovery.busybusy.io/beta
const betaFallback: TDiscoveryManifestCollection = {
  'admin-email-unsubscribe': {
    meta: {
      description: 'Call to unsubscribe a user from weekly admin email reports.',
      type: 'json-rpc',
      method: 'POST',
    },
    url: 'https://rpc-beta.busybusy.io/email-report',
    protocol: 'https',
    port: '443',
    domain: 'rpc-beta.busybusy.io',
    path: '/email-report',
  },

  'time-entry-export': {
    meta: {
      'description': 'Provides broad time entry CSV export capability for import into other systems',
      'type': 'REST',
      'method': 'GET',
      'content-type': 'text/csv',
    },
    url: 'https://export-beta.busybusy.io',
    protocol: 'https',
    port: '443',
    domain: 'export-beta.busybusy.io',
    path: '/',
  },
};

const fallbackManifestsDictionary: TDiscoveryManifestFallback = {
  production: productionFallback,
  staging: stagingFallback,
  beta: betaFallback,
  localhost: null as unknown as TDiscoveryManifestCollection,
};

export const getFallbackManifest = (env: TDiscoveryEnvironmentKeys = CURRENT_ENV) => {
  if (!fallbackManifestsDictionary.hasOwnProperty(env)) {
    throw new Error(`The Discovery Manifest does not support the specified environment: ${env}`);
  }

  return fallbackManifestsDictionary[env];
};

// These are all read only values, make sure they aren't accidentally modified
Object.freeze(productionFallback);
Object.freeze(stagingFallback);
Object.freeze(betaFallback);
Object.freeze(fallbackManifestsDictionary);
